import { Link } from 'react-router-dom';

import CatalogIcon from 'assets/images/menu/catalog.svg?react';
import DashboardIcon from 'assets/images/menu/dashboard.svg?react';
import FinancesIcon from 'assets/images/menu/finances.svg?react';
import LinksIcon from 'assets/images/menu/links.svg?react';
import MyOffersIcon from 'assets/images/menu/my-offers.svg?react';
import ReportsIcon from 'assets/images/menu/reports.svg?react';
import SourcesIcon from 'assets/images/menu/sources.svg?react';
import ToolsIcon from 'assets/images/menu/tools.svg?react';
import { ESourceRelationStatuses } from 'entities/Offer';
import { EFilters } from 'features/Filters';
import { i18n } from 'i18n';
import { EMainRoutes } from 'shared/typings';

export const MENU_ITEMS = () => [
	{
		label: <Link to={`/${EMainRoutes.DASHBOARD}`}>{i18n.t('Дашборд')}</Link>,
		key: EMainRoutes.DASHBOARD,
		icon: <DashboardIcon />,
	},
	{
		label: <Link to={`/${EMainRoutes.CATALOG}`}>{i18n.t('Каталог')}</Link>,
		key: EMainRoutes.CATALOG,
		icon: <CatalogIcon />,
	},
	{
		label: (
			<Link to={`/${EMainRoutes.MY_OFFERS}/?${EFilters.STATUS}=${ESourceRelationStatuses.JOINED}`}>
				{i18n.t('Мои офферы')}
			</Link>
		),
		key: EMainRoutes.MY_OFFERS,
		icon: <MyOffersIcon />,
	},
	{
		label: <Link to={`/${EMainRoutes.SOURCES}`}>{i18n.t('Мои площадки')}</Link>,
		key: EMainRoutes.SOURCES,
		icon: <SourcesIcon />,
	},
	{
		label: <Link to={`/${EMainRoutes.TOOLS}`}>{i18n.t('Инструменты')}</Link>,
		key: EMainRoutes.TOOLS,
		icon: <ToolsIcon />,
	},
	{
		label: <Link to={`/${EMainRoutes.FINANCES}`}>{i18n.t('Финансы')}</Link>,
		key: EMainRoutes.FINANCES,
		icon: <FinancesIcon />,
	},
	{
		label: <Link to={`/${EMainRoutes.REPORTS}`}>{i18n.t('Статистика и отчеты')}</Link>,
		key: EMainRoutes.REPORTS,
		icon: <ReportsIcon />,
	},
	{
		label: <Link to={`/${EMainRoutes.LINKS}`}>{i18n.t('Ссылки')}</Link>,
		key: EMainRoutes.LINKS,
		icon: <LinksIcon />,
	},
];
